<template>
	<div class="md-layout text-center">
		<div class="md-layout-item md-size-66 md-medium-size-80 md-small-size-90 md-xsmall-size-100">
			<md-card class="account-deletion-card">
				<md-card-content class="deletion-content">
					<h3 class="main-title">Exclusão de Conta</h3>

					<p class="intro-text">Para excluir a sua conta do aplicativo <strong>Gerenciador Mobile</strong>, envie um e-mail para <a href="mailto:tecnologia.info@cljrelacoesinstitucionais.com.br" class="email-link">tecnologia.info@cljrelacoesinstitucionais.com.br</a> com as informações abaixo:</p>

					<ul class="info-list">
						<li>Nome completo</li>
						<li>E-mail cadastrado</li>
						<li>CPF</li>
						<li>Número de telefone/celular</li>
					</ul>

					<h4 class="section-title">Os dados abaixo serão excluídos:</h4>

					<ul class="data-list deleted">
						<li>Nome</li>
						<li>E-mail</li>
						<li>Telefone</li>
						<li>Senha de acesso</li>
						<li>Foto de perfil</li>
						<li>Setores vinculados</li>
					</ul>

					<h4 class="section-title">Os dados abaixo serão armazenados:</h4>

					<p class="legal-text">
						O armazenamento dos dados abaixo é necessário para cumprimento de obrigações legais, trabalhistas e fiscais, conforme disposto no art. 16, I da Lei 13.709/2018.
					</p>

					<ul class="data-list retained">
						<li>Histórico de plantões realizados</li>
						<li>Histórico de escalas</li>
						<li>Registros de pagamentos e folha de pagamento</li>
						<li>Dados financeiros e contábeis</li>
						<li>Logs de auditoria do sistema</li>
					</ul>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
export default {
	name: "AccountDeletion",
	data() {
		return {};
	},
};
</script>

<style lang="scss" scoped>
.md-layout {
	margin-top: 0;
}

.account-deletion-card {
	margin: 30px auto;
	background: white;
	box-shadow: none;
	border-radius: 6px;

	.md-card-content {
		padding: 60px 80px !important;
	}
}

.deletion-content {
	text-align: left;
	color: #3c4858;
	line-height: 1.8;

	.main-title {
		font-size: 28px;
		font-weight: 400;
		color: #3c4858;
		margin: 0 0 30px 0;
		text-align: center;
	}

	.intro-text {
		font-size: 16px;
		color: #3c4858;
		line-height: 1.8;
		margin-bottom: 25px;

		strong {
			font-weight: 600;
		}
	}

	.email-link {
		color: #0c4da2;
		text-decoration: none;
		font-weight: 500;

		&:hover {
			text-decoration: underline;
		}
	}

	.info-list,
	.data-list {
		list-style: none;
		padding-left: 0;
		margin: 20px 0 30px 0;

		li {
			font-size: 16px;
			color: #3c4858;
			line-height: 2;
			position: relative;
			padding-left: 0;

			&:before {
				content: none;
			}
		}
	}

	.section-title {
		font-size: 16px;
		font-weight: 600;
		color: #3c4858;
		margin: 35px 0 15px 0;
	}

	.data-list.deleted {
		li {
			color: #3c4858;
		}
	}

	.data-list.retained {
		li {
			color: #3c4858;
		}
	}

	.legal-text {
		font-size: 16px;
		color: #3c4858;
		font-style: italic;
		line-height: 1.8;
		margin: 15px 0 20px 0;
	}
}

@media (max-width: 768px) {
	.account-deletion-card {
		margin: 15px auto;

		.md-card-content {
			padding: 40px 30px !important;
		}
	}

	.deletion-content {
		.main-title {
			font-size: 24px;
		}

		.intro-text,
		.info-list li,
		.data-list li,
		.section-title,
		.legal-text {
			font-size: 15px;
		}
	}
}
</style>
